var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('subMenu',{attrs:{"activeTab":_vm.activeTab}}),_c('div',{staticClass:"flex-between main-box"},[_c('videoProduct'),_c('newProduct')],1),_c('ecosystemList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }